import { ContactUsSchemaType } from "@/schemas/contact-us";
import { useLocalStorage } from "react-use";

export function useContactUsEmailStorage() {
  const KEY = "contact-us-email";

  const [value, setValue, clear] =
    useLocalStorage<Partial<ContactUsSchemaType>>(KEY);

  const set = (data: ContactUsSchemaType) => {
    setValue(data);
  };

  return {
    value: value ?? null,
    set,
    clear,
  };
}
